module.exports = __webpack_public_path__ + "img/user07.6218cce3.png";